/**
 * WhatsHotPage duck - minimal Redux duck for placeholder page
 * This will be expanded when the actual trending/hot content functionality is implemented
 */

// ================ Action types ================ //

export const WHATS_HOT_PAGE_LOAD_DATA = 'app/WhatsHotPage/LOAD_DATA';

// ================ Reducer ================ //

const initialState = {
  // Placeholder state - will be expanded for actual trends data
  isLoading: false,
  error: null,
};

export default function whatsHotPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case WHATS_HOT_PAGE_LOAD_DATA:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const whatsHotPageLoadData = () => ({
  type: WHATS_HOT_PAGE_LOAD_DATA,
});

// ================ Thunks ================ //

// Minimal loadData function that returns null for now
// This will be expanded when actual trending data loading is implemented
export const loadData = (params, search) => {
  return (dispatch, getState, sdk) => {
    // For now, just dispatch a simple action and return null
    dispatch(whatsHotPageLoadData());
    return Promise.resolve(null);
  };
};